import { render } from "./GeneralTestingBlockPage.vue?vue&type=template&id=59a4c4f2&scoped=true"
import script from "./GeneralTestingBlockPage.vue?vue&type=script&lang=js"
export * from "./GeneralTestingBlockPage.vue?vue&type=script&lang=js"

import "./GeneralTestingBlockPage.vue?vue&type=style&index=0&id=59a4c4f2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a4c4f2"]])

export default __exports__